import CloseIcon from 'mdi-react/CloseIcon';
import NoteTextOutlineIcon from 'mdi-react/NoteTextOutlineIcon';
import FileDocumentBoxSearchIcon from 'mdi-react/FileDocumentBoxSearchIcon';
import CalendarCheckIcon from 'mdi-react/CalendarCheckIcon';
import PackageDownIcon from 'mdi-react/PackageDownIcon';
import BeakerCheckOutlineIcon from 'mdi-react/BeakerCheckOutlineIcon';
import CogIcon from 'mdi-react/CogIcon';
import CurrencyUsdIcon from 'mdi-react/CurrencyUsdIcon';
import ClipboardTextOutlineIcon from 'mdi-react/ClipboardTextOutlineIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import BarleyIcon from 'mdi-react/BarleyIcon';
import SproutIcon from 'mdi-react/SproutIcon';
import AccountCheckIcon from 'mdi-react/AccountCheckIcon';
import SprayIcon from 'mdi-react/SprayIcon';
import ToyBrickSearchIcon from 'mdi-react/ToyBrickSearchIcon';
import WaterIcon from 'mdi-react/WaterIcon';
import ClockIcon from 'mdi-react/ClockIcon';
import ClipboardTextClockIcon from 'mdi-react/ClipboardTextClockIcon';
import ClipboardCheckOutlineIcon from 'mdi-react/ClipboardCheckOutlineIcon';
import ClockRemoveIcon from 'mdi-react/ClockRemoveIcon';
import TextBoxCheckIcon from 'mdi-react/TextBoxCheckIcon';
import TextBoxRemoveIcon from 'mdi-react/TextBoxRemoveIcon';
import AccountHardHatIcon from 'mdi-react/AccountHardHatIcon';
import AccountStarIcon from 'mdi-react/AccountStarIcon';
import React from 'react';

export const {
  API_URL, CURRENT_VERSION, MAP_API_KEY, MAP_CHANNEL_VERSION,
  BUILD_NUMBER, SAP_API_BASE_URL, SAP_USER, SAP_PASSWORD,
} = process.env;
export const CHECK_REGISTRATION_URL = `${SAP_API_BASE_URL}ValidarMatricula`;
export const SAP_GET_MATRICULATION_CREDIT_BALANCE_URL = `${SAP_API_BASE_URL}MatriculaSaldo`;
export const SAP_LIST_ACCOUNTS_PAYABLE_URL = `${SAP_API_BASE_URL}ContasPagar`;
export const SAP_DOWNLOAD_SEND_BANK_SLIP_URL = `${SAP_API_BASE_URL}Boleto`;
export const FIDELITY_GET_PRODUCTS_BY_SEGMENT_ENDPOINT = `${SAP_API_BASE_URL}DetalheSegmento`;
export const FIDELITY_GET_SEGMENTS_ENDPOINT = `${SAP_API_BASE_URL}Segmento`;
export const SAP_GET_DATA_USER = `${SAP_API_BASE_URL}bp`;
export const CHECK_REGISTRATION_USERNAME = SAP_USER;
export const CHECK_REGISTRATION_PASSWORD = SAP_PASSWORD;
export const INVALID_ACCESS_TOKEN_ERROR_CODE = '';
export const INVALID_REFRESH_TOKEN_ERROR_CODE = '';
export const AUTH_URL = '/authentications';
export const ENCRYPTION_KEY = 'Mn4y9tcHQM'; // for browser storage encryption
export const SERVER_URL = API_URL;
export const VERSION = CURRENT_VERSION;

export const RESTRUCTURED_SERVICES = [
  'GEOFERT-COLETA_TALHOES',
  'GEOFERT-CLASSIFICACAO_SOLO_AMBIENTE_PRODUCAO',
  'GEOFERT-GRID',
  'GEOFERT-ZONA_MANEJO-SATELITE',
  'GEOFERT-ZONA_MANEJO-VANT',
  'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA',
  'VANT-ORTOMOSAICO',
  'VANT-SISTEMATIZACAO',
  'VANT-PROJETO_PLANTIO',
  'VANT-LEVANTAMENTO_FALHAS',
  'VANT-MAPEAMENTO_LINHAS',
  'VANT-MAPEAMENTO_ERVAS_INVASORAS',
  'VANT-ZONA_MANEJO',
];

export const RESTRUCTURED_SERVICES_NAMES = [
  'Geofert Coleta por talhões',
  'Geofert Classificação de solo e Ambiente de produção',
  'Geofert Grid',
  'Geofert Zona de manejo Satélite',
  'Geofert Zona de manejo Vant',
  'Geofert Zona de manejo Condutividade elétrica',
  'Pós-vendas Assistência técnica',
  'Pós-vendas Locação de piloto',
  'Pós-vendas Montagem de equipamento',
  /* 'Vant Ortomosaico',
  'Vant Sistematização',
  'Vant Projeto de plantio',
  'Vant Levantamento de falhas',
  'Vant Mapeamento de linhas',
  'Vant Mapeamento de ervas invasoras',
  'Vant Zona de manejo', */
];

export const isRestructuredService = (serviceName: string): boolean => {
  const resultado = RESTRUCTURED_SERVICES_NAMES.includes(serviceName.trim());
  console.log('serviceName', serviceName);
  console.log('reestruturado?', resultado);
  return resultado;
};

export const TYPE_USER = [
  { id: 1, icon: <AccountHardHatIcon /> },
  { id: 2, icon: <AccountStarIcon /> },
];

export const SERVICE_STAUS = [
  { id: -1, icon: <CloseIcon /> },
  { id: 0, icon: <CloseIcon /> },
  { id: 1, icon: <NoteTextOutlineIcon /> },
  { id: 2, icon: <FileDocumentBoxSearchIcon /> },
  { id: 3, icon: <CalendarCheckIcon /> },
  { id: 4, icon: <PackageDownIcon /> },
  { id: 5, icon: <BeakerCheckOutlineIcon /> },
  { id: 6, icon: <CogIcon /> },
  { id: 7, icon: <CurrencyUsdIcon /> },
  { id: 8, icon: <ClipboardTextOutlineIcon /> },
  { id: 9, icon: <CheckIcon /> },
  { id: 10, icon: <BarleyIcon /> },
  { id: 11, icon: <SproutIcon /> },
  { id: 12, icon: <AccountCheckIcon /> },
  { id: 13, icon: <SprayIcon /> },
  { id: 14, icon: <ToyBrickSearchIcon /> },
  { id: 15, icon: <WaterIcon /> },
  { id: 16, icon: <CogIcon /> },
  { id: 17, icon: <AccountCheckIcon /> },
  { id: 18, icon: <ClipboardCheckOutlineIcon /> },
];

export const ESTIMATE_STATUS = [
  { id: 1, icon: <ClockIcon /> },
  { id: 2, icon: <ClipboardTextClockIcon /> },
  { id: 3, icon: <TextBoxCheckIcon /> },
  { id: 4, icon: <TextBoxRemoveIcon /> },
  { id: 5, icon: <ClockRemoveIcon /> },
];

export const STATES = [
  { initials: 'AC', state: 'Acre' },
  { initials: 'AL', state: 'Alagoas' },
  { initials: 'AP', state: 'Amapá' },
  { initials: 'AM', state: 'Amazonas' },
  { initials: 'BA', state: 'Bahia' },
  { initials: 'CE', state: 'Ceará' },
  { initials: 'DF', state: 'Distrito Federal' },
  { initials: 'ES', state: 'Espírito Santo' },
  { initials: 'GO', state: 'Goiás' },
  { initials: 'MA', state: 'Maranhão' },
  { initials: 'MT', state: 'Mato Grosso' },
  { initials: 'MS', state: 'Mato Grosso do Sul' },
  { initials: 'MG', state: 'Minas Gerais' },
  { initials: 'PA', state: 'Pará' },
  { initials: 'PB', state: 'Paraíba' },
  { initials: 'PR', state: 'Paraná' },
  { initials: 'PE', state: 'Pernambuco' },
  { initials: 'PI', state: 'Piauí' },
  { initials: 'RJ', state: 'Rio de Janeiro' },
  { initials: 'RN', state: 'Rio Grande do Norte' },
  { initials: 'RS', state: 'Rio Grande do Sul' },
  { initials: 'RO', state: 'Rondônia' },
  { initials: 'RR', state: 'Roraima' },
  { initials: 'SC', state: 'Santa Catarina' },
  { initials: 'SP', state: 'São Paulo' },
  { initials: 'SE', state: 'Sergipe' },
  { initials: 'TO', state: 'Tocantins' },
];

export const WEEKDAYS = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
  'Feriados',
];

export const MONTH_OF_THE_YEAR = {
  JANUARY: 'Janeiro',
  FEBRUARY: 'Fevereiro',
  MARCH: 'Março',
  APRIL: 'Abril',
  MAY: 'Maio',
  JUNE: 'Junho',
  JULY: 'Julho',
  AUGUST: 'Agosto',
  SEPTEMBER: 'Setembro',
  OCTOBER: 'Outubro',
  NOVEMBER: 'Novembro',
  DECEMBER: 'Dezembro',
};

export const MONTH = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
];

export const depthReferenceIdCodeList = [
  { idCode: 'GEOFERT-GRID-PROFUNDIDADE_1', value: 'Profundidade 1' },
  { idCode: 'GEOFERT-GRID-PROFUNDIDADE_2', value: 'Profundidade 2' },
  { idCode: 'GEOFERT-GRID-PROFUNDIDADE_3', value: 'Profundidade 3' },
  { idCode: 'GEOFERT-GRID-PROFUNDIDADE_4', value: 'Profundidade 4' },
  { idCode: 'GEOFERT-GRID-PROFUNDIDADE_5', value: 'Profundidade 5' },
];
